import { GzGeneralDonutChartWebComponent } from './component/GzGeneralDonutChartWebComponent';
export { GzGeneralDonutChartWebComponent };
